import $ from 'jquery';
import state from '../../core/offsetState.js';
import {urgentNewsSpacerHeight} from "../../jquery/common/header/urgentNewsSpacer";
import {NEWS_URGENT_NEWS} from "Core/links";

const renew = () => {
    $.get(NEWS_URGENT_NEWS, (response) => {
        let urgentNewsBlock = $('.content-row.urgent-news');
        const urgentNewsSpacer = $('.urgent-news-spacer');

        if (response.html.length === 0) {
            if (urgentNewsBlock.length > 0) {
                urgentNewsBlock.slideUp();
                urgentNewsSpacer.slideUp();
                state.changeUrgentNewsHeight(0);
            }

            return;
        }

        let urgentNews = $(response.html);

        if (urgentNewsBlock.length > 0) {
            urgentNewsBlock.replaceWith(response.html);
            setTimeout(() => {
                urgentNewsSpacerHeight();
            }, 500);
            return;
        }


        urgentNews.hide();

        $('.wrapper__content').prepend(urgentNews);
        urgentNewsBlock = $('.content-row.urgent-news');

        urgentNewsBlock.slideDown();
        urgentNewsSpacer.slideDown();
        setTimeout(() => {
            urgentNewsSpacerHeight();
        }, 500);
    }, 'json');
};

export default renew;
